import {axiosBffFetch} from '../../axios/axiosBffFetch';
import {requestContext} from '../../common/requestContext';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {OpenLogVo} from '../../common/shared/api/nicolas/vo/OpenLogVo.interface';

/**
 * 미리보기 열람
 *
 * Origin: pageNicolasApi.openPreview
 * API: POST /api/v1/inven/open_preview
 */
export async function postInvenOpenPreview({
  seriesId,
  productId,
}: {
  seriesId: number;
  productId: number;
}): Promise<ApiResultVo & {open_log: OpenLogVo}> {
  const {deviceId} = requestContext.requestInfo;
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/inven/open_preview',
    {
      method: 'POST',
      data: {
        seriesId,
        productId,
        // 필수값은 아니지만 비로그인 상태에 유의미하게 사용하는 값이라 데이터분석팀 요청으로 추가합니다.
        transactionId: deviceId,
      },
    }
  );
  return response.data;
}
